import React from 'react'
import PropTypes from 'prop-types'
import { Tooltip } from '../../../../../../imports'
import styles from '../../../../../../styles.scss'

const LayoutItem = (props) => {
    const style = props.selected ? `${styles[props.value]} ${styles.selected}` : styles[props.value]
    const onClick = () => {
        props.save(props.value)
        props.showMessage()
    }
    return (
        <Tooltip key={props.value} content={props.label} style={{ display: 'block' }}>
            <li className={style} aria-hidden onClick={onClick}>
                <i className="flaticon flaticon-two" />
            </li>
        </Tooltip>
    )
}

LayoutItem.propTypes = {
    selected: PropTypes.bool,
    value: PropTypes.string,
    label: PropTypes.string,
    save: PropTypes.func,
    showMessage: PropTypes.func,
}

export default LayoutItem



// WEBPACK FOOTER //
// ./src/features/Settings/components/Settings/components/Layout/components/LayoutItem/index.js